(ns trellis.search-input
  (:require [dnd.util :refer [cls]]
            [clojure.string :as str]))

(defn search-icon
  []
  [:svg {:aria-hidden "true"
         :xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 32 32"
         :focusable "false"
         :data-icon-name "Search"}
   [:path {:d "m29.66 27.7-8.36-8.36c1.4-1.8 2.24-4.09 2.24-6.58C23.54 6.82 18.72 2 12.78 2S2.01 6.82 2.01 12.76s4.82 10.76 10.76 10.76c2.49 0 4.78-.84 6.6-2.26l-.02.02 8.34 8.36c.24.22.57.36.92.36.76 0 1.38-.62 1.38-1.38 0-.36-.14-.68-.36-.93s.03 0 .03 0Zm-16.84-6.94c-4.4 0-7.96-3.58-7.96-7.97s3.57-7.97 7.97-7.97 7.97 3.57 7.97 7.97v.03c-.02 4.39-3.59 7.95-7.98 7.95Z"}]])

(defn clear-icon
  []
  [:svg {:aria-hidden "true"
         :xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 32 32"
         :focusable "false"
         :data-icon-name "Remove"}
   [:path {:d "M2.57 29.48c.32.32.75.51 1.24.51s.92-.2 1.24-.51L16.03 18.5l11 10.98c.32.32.75.51 1.24.51A1.752 1.752 0 0 0 29.51 27l-11-10.98 10.98-11c.28-.31.46-.72.46-1.17a1.741 1.741 0 0 0-2.92-1.28s-11 10.98-11 10.98l-11-10.98a1.741 1.741 0 1 0-2.47 2.45s10.98 11 10.98 11l-10.97 11c-.31.31-.51.75-.51 1.23s.19.92.51 1.23"}]])

(defn icon-wrapper
  [{:keys [visible]}]
  {:pre [(boolean? visible)]}
  [:div {:data-comp-name "icon-wrapper"
         :class (cls "whitespace-nowrap"
                     "inline-flex"
                     "items-center"
                     "h-full"

                     (if visible
                       "visible"
                       "invisible")

                     ;; color
                     "text-trellis-color-icon-core-default"

                     ;; margin
                     "mx-trellis-space-400")}
   [search-icon]])

(defn clear-input
  [{:keys [onClick]}]
  [:button {:data-comp-name "clear-input"
            :tabIndex 0
            :type "button"
            :onClick onClick
            :class (cls "absolute"
                        "right-trellis-space-25"
                        "top-trellis-space-25"
                        "h-full"
                        "flex"
                        "items-center justify-center"
                        "px-trellis-space-400"

                        "focus:outline"
                        "focus:outline-trellis-border-width-200"
                        "focus:outline-trellis-color-border-info-default"
                        "focus:outline-offset-[-2px]")}
   [clear-icon]])

(defn message-wrapper
  [props & children]
  (into [:div {:data-comp-name "message-wrapper"
               :class (cls "absolute"
                           "top-trellis-space-25"
                           "right-trellis-space-25"
                           "bottom-trellis-space-25"
                           "pointer-events-none")}]
        children))

(defn search-input
  [{:keys [;; input
           value
           placeholder
           autoFocus
           ;; output
           onChange
           onClear]}]
  [:div {:class (cls "relative inline-block w-full"

                     ;; size the icons
                     "[&_svg[data-icon-name]]:size-[16px]"
                     "[&_svg[data-icon-name]]:leading-[16px]"
                     "[&_svg[data-icon-name]]:text-current")}
   ;; TODO: id/name
   [:input {:role "searchbox"
            :type "search"
            :value value
            :onChange onChange
            :autoFocus (boolean autoFocus)
            :placeholder placeholder
            :class (cls "appearance-none"
                        "block"
                        "text-left"
                        "transition-all"
                        "w-full"
                        "align-middle"
                        "m-0"

                        ;; font
                        "text-trellis-typography-body-200-font-size"
                        "leading-trellis-typography-body-200-line-height"
                        "tracking-trellis-typography-body-200-letter-spacing"

                        ;; padding
                        "p-trellis-space-200"
                        "pr-trellis-space-1000"

                        ;; bg / text color
                        "bg-trellis-color-fill-field-default"
                        "text-trellis-color-text-core-default"
                        "placeholder:text-trellis-color-text-core-subtle"

                        ;; border
                        "border-trellis-border-width-100"
                        "border-trellis-color-border-core-default"
                        "focus:border-trellis-color-transparent"
                        "focus:outline"
                        "focus:outline-trellis-border-width-200"
                        "focus:outline-trellis-color-border-info-default"
                        "focus:outline-offset-[-2px]"

                        ;; border radius
                        "rounded-trellis-border-radius-full")}]
   [message-wrapper {}
    [icon-wrapper {:visible (str/blank? value)}]]

   (when-not (str/blank? value)
     [clear-input {:onClick onClear}])])

